<template>
  <div>
    <div class="todo-wrapper px-3 pb-12 mb-2">
      <task-item v-for="task in tasks" :key="task._id" :task="task" />
      <div v-if="tasks.length === 0 && !inEditor" class="pa-3">
        No Tasks available
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TaskItem from '../../hoc/TaskItemBoundary.vue';

export default {
  name: 'TodoList',
  components: {
    TaskItem
  },
  props: {
    inEditor: Boolean,
    enableButton: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    if (this.enableButton) {
      this.$store.commit('navigation/showButton', {
        site: 'sdp',
        buttonName: 'addTask'
      });
    }
    if (this.$store.state.tasks.createdItems.length > 0) {
      this.$store.commit('tasks/resetCreatedItems');
    }
  },
  destroyed() {
    this.$store.commit('navigation/hideButton', {
      site: 'sdp',
      buttonName: 'addTask'
    });
  },
  computed: {
    ...mapState('tasks', {
      tasks: state => state.items
    })
  }
};
</script>

<style lang="scss" scoped>
.todo-wrapper {
  display: block;
  overflow: hidden;
}
</style>
